export default __webpack_public_path__ + "static/media/edit-desabilitado.046e38c7.svg";